export default __webpack_public_path__ + "images/offsides_mark.86ec86.png";